import DateFnsUtils from "@date-io/date-fns";
import { FormHelperText } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import { DatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Prompt } from "react-router";
import { Link, Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { harvestYearDetail } from "../../../config/harvestYearDetail";
import TabsConstants from "../../../constants";
import {
  commodityList,
  getAllContractList,
  getCommodityVariertyList,
  getContractStage,
  getContractType,
  getDestinationByType,
  getSelectedContractDetail,
  InternalDestinationList
} from "../../../modules/contract/action";
import { getMandatoryFieldsList } from "../../../modules/mandatoryFields/action";
import {
  createNewTicket,
  getCounterpartList,
  getLoadIndicatorCodeCount,
  getLoadNumberIndicatorList,
  getOriginType
} from "../../../modules/ticket/action";
import { trucklineListAction } from "../../../modules/truckline/action";
import "../../../style";
import LogInfo from "../../../utils/LogInfo";
import Button from "../../FormElement/Button";
import Dropdown from "../../FormElement/Dropdown";
import { validForm } from "../../FormElement/FormValidator";
import InputFiled from "../../FormElement/InputFiled";
import RadioElement from "../../FormElement/RadioElement";
import Loader from "../../Loader";
import { options } from "sw-toolbox";
import "../../../style/main.css";

const defaultDestinationTypeId = "2";
const originTypes = ["", "Primary Field", "On-site Storage"];

const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

const styles = {
  root: {
    color: "#00bc84",
    "&$checked": {
      color: "#00bc84"
    }
  },
  checked: {}
};
class TicketForm extends Component {
  handleVarietyonEdit = false;
  constructor(props) {
    super(props);

    this.state = {
      ticketInfo: {
        ...this.props.ticketInfo,
        loadDate: this.props.ticketInfo
          ? new Date(this.props.ticketInfo.loadDate)
          : new Date(),
        shrinkMultiplier: this.props.ticketInfo.shrinkMultiplier
          ? this.props.ticketInfo.shrinkMultiplier
          : "1",
        harvestYear: harvestYearDetail().name,
        notes: null,
        // secondaryFieldSplit: "",
        // secondarySourceId: ""
      },
      ONBOARDED:'ONBOARDED',
      formErrors: {
        commodityId: "",
        commodityVarietyId: "",
        commodityVarietyId: "",
        originTypeId: "",
        primarySourceId: "",
        secondarySourceId: "",
        loadNumberIndicatorId: "",
        secondaryFieldSplit: ""
      },
      originTypeOptions: [],
      DestinationOptionList: [],
      commodityVarietyListOption: [],
      suggestedDestinationOptionList: { ticket: [], contract: [] },
      successMessage: "",
      checked: false,
      contractOptionsList: [],
      isValid: props.isValid,
      destinationLoadCost: null,
      commodityVarietyLbsPerBushel: 0,
      edited: false,
      mandatoryFields: [],
      fetchingComplete: false,
      showSecondaryFields: false,
      isEnableShowSplit: true,
    };
  }

  componentWillMount() {
    
  }

  updateMandatoryCells = ()=>{
    this.props.actions
      .getMandatoryFieldsList("Ticket")
      .then(mandatoryFieldsList => {
        this.setState({
          mandatoryFields: mandatoryFieldsList
            .filter(item => item.enable === true)
            .map(item => item.fieldName)
        });
        this.showExtendedDetails();
      });
  }

  componentDidMount() {
    const destinationType = "External";
    // this.props.actions.getMandatoryFieldsList("Ticket");
    const timestamp = Date.now();
    let id = this.props.SubFarmId
      ? this.props.SubFarmId
      : userFarmDetail().id
      ? userFarmDetail().id
      : this.props.MainFarmId;
    const harvestYearId = harvestYearDetail().name;
    this.props.actions.getAllContractList(id, harvestYearId);
    this.props.actions.getCommodityVariertyList(harvestYearId).then(() => {
      this.props.actions.commodityList();
      if (this.props.ticketInfo.commodityId) {
        this.getVariertyList(this.props.ticketInfo.commodityId);
      }
    });
    this.props.actions.getCounterpartList();
    this.props.actions.getContractStage();
    this.props.actions.getContractType();
    this.props.actions.getOriginType();
    this.props.actions.getLoadNumberIndicatorList(harvestYearId);
    this.props.actions.getDestinationByType(destinationType, harvestYearId);
    this.props.actions
      .InternalDestinationList("Internal", harvestYearId)
      .then(() => {
        let destId = this.props.ticketInfo.destinationTypeId
          ? this.props.ticketInfo.destinationTypeId
          : defaultDestinationTypeId;
        this.getDestinationOptionList(destId);
        if (this.props.ticketInfo.originTypeId) {
          this.getOriginOnTypeBasis(this.props.ticketInfo.originTypeId);
        }
        this.setState({ fetchingComplete: true });
      });
    this.props.actions.trucklineListAction();
    this.updateMandatoryCells();
  }

  componentDidUpdate() {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  }

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedContractDetails &&
      nextProps.selectedContractDetails !== this.props.selectedContractDetails
    ) {
      const {
        counterpartResponseDTO,
        commodityVarietyResponseDTO,
        contractType,
        destination
      } = nextProps.selectedContractDetails;
      this.setState(
        prevState => {
          return {
            ticketInfo: {
              ...prevState.ticketInfo,
              counterpartId: counterpartResponseDTO
                ? counterpartResponseDTO.id
                : "",
                ONBOARDED:counterpartResponseDTO.onBoarded,
              commodityId:
                commodityVarietyResponseDTO &&
                commodityVarietyResponseDTO.commodityResponseDTO.id,
              commodityVarietyId:
                commodityVarietyResponseDTO &&
                this.getVariertyList(
                  commodityVarietyResponseDTO.commodityResponseDTO.id,
                  commodityVarietyResponseDTO.id
                ),
              //type: contractType.id,
              destinationId:
                commodityVarietyResponseDTO && destination ? destination.id : ""
              // shrinkMultiplier : shrinkMultiplier && shrinkMultiplier ? shrinkMultiplier : "1"
            },
            formErrors: {
              ...prevState.formErrors,
              destinationId: "",
              counterpartId: ""
            }
            // destinationLoadCost:
            //   commodityVarietyResponseDTO && destination
            //     ? destination.loadCostPerBushel
            //     : 0,
            // commodityVarietyLbsPerBushel:
            //   commodityVarietyResponseDTO &&
            //   commodityVarietyResponseDTO.commodityResponseDTO
            //     .lbsPerBushel
          };
        },
        () => {
          this.getfieldEstimatedLoadBushels();
          this.getcommidityLoadBushlesValue();
          this.getdestinationsBushelsValue(this.state.ticketInfo.destinationId);
          
        }
      );
      console.log(commodityVarietyResponseDTO.commodityResponseDTO.id,this.state.ticketInfo.commodityId,"commoid");
    }
    if (this.props.editMode || this.props.commodityList) {
     
      this.getfieldEstimatedLoadBushels();
      this.getcommidityLoadBushlesValue();
      this.getdestinationsBushelsValue(this.props.ticketInfo.destinationId);
    }
  }
  getOriginOnTypeBasis = id => {
    let mode = this.props.editMode;
    // if (!mode) {
    this.setState(prevState => {
      return {
        originTypeOptions: "",
        ticketInfo: {
          ...prevState.ticketInfo
        }
      };
    });
    // }
    if (id === "1") {
      this.setState({
        originTypeOptions: this.props.OriginTypeDestinationOptions,
        suggestedFieldOriginTypeOptions: this.props.suggestedOriginType,
        showSecondaryFields: true
      });
    } else if (id === "2") {
      this.setState({
        originTypeOptions: this.props.InternalDestinationOptions,
        suggestedInternalOriginTypeOptions: this.props.suggestedInternalOptions,
        showSecondaryFields: false
      });
    }
  };
  getDestinationOptionList = id => {
    if (id === "1") {
      this.setState({
        DestinationOptionList: this.props.InternalDestinationOptions,
        suggestedDestinationOptionList: this.props.suggestedInternalOptions
      });
      this.setState(prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            commodityId: "",
            commodityVarietyId: "",
            destinationId: "",
            originTypeId: "",
            primarySourceId: "",
            secondarySourceId: "",
            loadNumberIndicatorId: ""
          }
        };
      });
    } else if (id === "2") {
      this.setState({
        DestinationOptionList: this.props.ExternalDestinationOptions,
        suggestedDestinationOptionList: this.props.suggestedExternalOptions
      });
      this.setState(prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            commodityId: "",
            commodityVarietyId: "",
            destinationId: "",
            originTypeId: "",
            primarySourceId: "",
            secondarySourceId: "",
            loadNumberIndicatorId: ""
          }
        };
      });
    }
  };

  getLoadNumberFromIndicator = id => {
    const { LoadNumberIndicatorList } = this.props;
    const timestamp = Date.now();
    const numberObject = LoadNumberIndicatorList.filter(
      value => value.id === id
    );
    let varCode = numberObject.length > 0 ? numberObject[0].code : "";
    const harvestYearId = harvestYearDetail().name;
   console.log('yeh wala',this.state.destinationLoadCost)
    this.props.actions
      .getLoadIndicatorCodeCount(varCode, harvestYearId)
      .then(codeCount => {
        this.setState(prevState => {
          return {
            ticketInfo: {
              ...prevState.ticketInfo,
              ["loadNumber"]: codeCount
            }
          };
        });
      });
      console.log('yeh wala1',this.state.destinationLoadCost)
  };

  getcommidityLoadBushlesValue = () => {
    
    const { ticketInfo } = this.state;
    const { commodityList } = this.props;
    let selectedCommodityArray = [];
    if (ticketInfo.commodityId !== "") {
      selectedCommodityArray =
        commodityList &&
        commodityList.filter(value => {
          if (value && value.id === ticketInfo.commodityId) {
            return value;
          }
        });
    }
    console.log(selectedCommodityArray,"tempbsl");
    this.setState(
      {
        commodityVarietyLbsPerBushel: Number(
          selectedCommodityArray[0] && selectedCommodityArray[0].lbsPerBushel
        )
      },
      () => {
        this.getExternalDestinationLoadCost();
        this.getEstimatedHomeScaleShrinkBushels();
      }
    );
  };
  getfieldEstimatedLoadBushels = () => {
    const { ticketInfo } = this.state;
    const { commodityList } = this.props;
    let dividend = ticketInfo.fieldEstimatedLoadWeight;
    let selectedCommodityArray = [];
    if (ticketInfo.commodityId !== "") {
      selectedCommodityArray =
        commodityList &&
        commodityList.filter(value => {
          if (value && value.id === ticketInfo.commodityId) {
            return value;
          }
        });
    }
    let finalCalulatedValue = "";
    if (
      selectedCommodityArray !== undefined &&
      selectedCommodityArray.length > 0 &&
      dividend
    ) {
      finalCalulatedValue = parseFloat(
        dividend / selectedCommodityArray[0].lbsPerBushel
      ).toFixed(2);
      // let finalCalulatedValue = Math.floor((dividend)/(selectedCommodityArray[0].lbsPerBushel))
      finalCalulatedValue =
        finalCalulatedValue === Infinity && isNaN(finalCalulatedValue === NaN)
          ? 0
          : finalCalulatedValue;
    }
    this.setState(
      prevState => {
        return {
          ticketInfo: {
            ...prevState.ticketInfo,
            ["fieldEstimatedLoadBushels"]: Number(finalCalulatedValue)
          }
        };
      },
      () => {
        this.getEstimatedHomeScaleShrinkBushels();
        this.getExternalDestinationLoadCost();
      }
    );
  };
  getSelectedContractDetail = contractName => {
    const { ContractList } = this.props;
    let contractId = "";
    let contract = Object.keys(ContractList).filter(
      value => ContractList[value].name === contractName
    );
    contractId = ContractList[contract] && ContractList[contract].id;
    this.props.actions.getSelectedContractDetail(contractId);
  };
  handleChange = event => {
    
    if (!this.state.edited) this.setState({ edited: true });
    const { name, type, label } = event.target;
    let { value } = event.target;
    if (type === "number") {
      value = Number(value);
    }
    switch (name) {
      case "commodityId":
        this.getVariertyList(value);
        break;
      case "originTypeId":
        this.getOriginOnTypeBasis(value);
        break;
      case "destinationTypeId":
        this.getDestinationOptionList(value);
        break;
      case "loadNumberIndicatorId":
        this.getLoadNumberFromIndicator(value);
        break;
      case "primaryContractNumber":
        this.getSelectedContractDetail(value);
        this.setState(prevState => {
          return {
            ticketInfo: {
              ...prevState.ticketInfo,
              ["primaryContractNumber"]: value
              //   commodityVarietyResponseDTO &&
              //   commodityVarietyResponseDTO.commodityResponseDTO.id,
              //["commodityVarietyId"]:
            }
          };
        });
        break;
      case "trucklineId":
        if (value === "" || value===undefined) {
          this.setState(prevState => {
            return {
              formErrors: {
                ...prevState.formErrors,
                truckNumber: "",
                driverName: ""
              }
            };
          });
          if(this.state.ticketInfo.destinationTypeId==="1")
          {
          this.state.isValid= validForm(this.state.formErrors);
          }
        }
        break;
      case "primarySourceId":
        this.setState(prevState => {
          return {
            ticketInfo: {
              ...prevState.ticketInfo,
              primarySourceId: value
            }
          };
        });
        break;
      case "secondarySourceId":
        this.setState(
          prevState => {
            return {
              ticketInfo: {
                ...prevState.ticketInfo,
                secondarySourceId: value
              }
            };
          },
          () => {
            this.updateMandate();
          }
        );
      default:
        break;
    }
    if (
      name === "fieldEstimatedLoadWeight" ||
      name === "fieldsEstimatedMoisture" ||
      name === "homeScaleWeightEmpty" ||
      name === "homeScaleWeightFilled" ||
      name === "homeScaleEstimatedMoisture" ||
      name === "shrinkMultiplier" ||
      name === "secondaryFieldSplit"
    ) {
      const regex =
        name === "shrinkMultiplier"
          ? /^\d{0,10}(\.\d{0,4})?$/
          : /^\d{0,10}(\.\d{0,2})?$/;
      if (value.match(regex)) {
        this.setState(
          prevState => {
            return {
              ticketInfo: {
                ...prevState.ticketInfo,
                [name]: value
              }
            };
          },
          () => {
            if (name === "fieldEstimatedLoadWeight" || name === "commodityId") {
              this.getfieldEstimatedLoadBushels();
              // this.getExternalDestinationLoadCost();
            }

            if (
              name === "homeScaleWeightFilled" ||
              name === "homeScaleWeightEmpty" ||
              name === "fieldEstimatedLoadBushels" ||
              name === "shrinkMultiplier"
            ) {
              this.getEstimatedHomeScaleShrinkBushels();
            }
            this.props.checkValidation(this.state.ticketInfo);
          }
        );
      }
    } else if (name === "comments") {
      if (value.match(/^(.|\n){0,256}$/)) {
        this.setState(prevState => {
          return {
            ticketInfo: {
              ...prevState.ticketInfo,
              [name]: value
            }
          };
        });
      }
      this.props.checkValidation(this.state.ticketInfo);
    } else if (
      name === "scaleTicketNumber" ||
      name === "billOfLading" ||
      name === "truckNumber" ||
      name === "trailerNumber"
    ) {
      if (value.match(/^(.|\n){0,21}$/)) {
        this.setState(prevState => {
          return {
            ticketInfo: {
              ...prevState.ticketInfo,
              [name]: value
            }
          };
        });
      }
      this.props.checkValidation(this.state.ticketInfo);
    } else if (name === "driverName") {
      if (value.match(/^(.|\n){0,51}$/)) {
        this.setState(
          prevState => {
            return {
              ticketInfo: {
                ...prevState.ticketInfo,
                [name]: value
              }
            };
          },
          () => {
            this.props.checkValidation(this.state.ticketInfo);
          }
        );
      }
    } else {
      if(name==="counterpartId" && label){
        this.setState({ONBOARDED:label.includes('✅')?'ONBOARDED':'VIRTUAL'
      })
      }

      this.setState(
        prevState => {
          return {
            ticketInfo: {
              ...prevState.ticketInfo,
              [name]: value
            }
          };
        },
        () => {
          if (name === "commodityId") {
            this.getfieldEstimatedLoadBushels();
            this.getcommidityLoadBushlesValue();
          }
          if (name === "destinationId") {
            this.getdestinationsBushelsValue(value);
          }
          this.props.checkValidation(this.state.ticketInfo);
        }
      );
    }
    // this.props.changeFunction(name,value)
    // this.props.checkValidation(this.state.ticketInfo);
  };

  getdestinationsBushelsValue = id => {
    var i, j;
    if(this.state.DestinationOptionList!=null && this.state.DestinationOptionList!=undefined)
    {
    for (i = 0; i < this.state.DestinationOptionList.length; i++) {
    if(this.state.DestinationOptionList[i].id==id)
    {
    if(this.state.DestinationOptionList[i].commodity!=null){
    this.getVariertyList(this.state.DestinationOptionList[i].commodity.commodityId,this.state.DestinationOptionList[i].commodityVariety.varietyId);
    const commovalid=this.state.DestinationOptionList[i].commodity.commodityId
    const varietyid=this.state.DestinationOptionList[i].commodityVariety.varietyId
    var lbsPerBushels
    for(j=0; j<this.props.commodityList.length; j++)
    {
       if(commovalid===this.props.commodityList[j].id)
       {
        // this.setState(prevState => {
        //   return {
        //   ...prevState,
          
        //   ticketInfo: {
        //   ...prevState.ticketInfo,
        //   commodityVarietyLbsPerBushel:this.props.commodityList[j].lbsPerBushel
        //   }
        //   };
        //   });
        lbsPerBushels=this.props.commodityList[j].lbsPerBushel
        console.log(this.props.commodityList[j].lbsPerBushel,"looop");
       }
    }
    //////////////////
    console.log(lbsPerBushels,"afterloop");
    this.setState(prevState => {
    return {
    ...prevState,
    
    ticketInfo: {
    ...prevState.ticketInfo,
    commodityId:commovalid,
    },
    };
    });
    this.setState(
      {
      commodityVarietyLbsPerBushel: Number(
      lbsPerBushels)
      },
      () => {
      this.getExternalDestinationLoadCost();
      this.getEstimatedHomeScaleShrinkBushels();
      }
      );
    console.log(this.state.ticketInfo,"newstate");
    }
    
    else if(this.state.ticketInfo.destinationTypeId==="1" ||(this.state.ticketInfo.destinationTypeId==="2" &&!this.state.ticketInfo.commodityId))
    {
      console.log(this.state.ticketInfo.destinationTypeId,this.props,"check dest");
      this.getVariertyList(this.props.ticketInfo.commodityId,this.props.ticketInfo.commodityVarietyId);
      console.log(this.props,"tempstate");
      this.setState(prevState => {
        return {...prevState,
        ticketInfo: {
        ...prevState.ticketInfo,
        commodityId:this.props.ticketInfo.commodityId,
        // commodityVarietyLbsPerBushel:this.props.
        }
        };
        });
    }
    }
    }
  }
    const {
    ExternalDestinationOptions,
    InternalDestinationOptions
    } = this.props;
    let combinedDestinationList = [
    ...(ExternalDestinationOptions || {}),
    ...(InternalDestinationOptions || {})
    ];
    var tempid
if(id){
  
  tempid=id

}
else{
  
tempid=this.state.ticketInfo.destinationId
}
let option = combinedDestinationList.filter(value => value.id === tempid);

    this.setState(
    prevState => {
    return {
    ...prevState,
    destinationLoadCost: option[0] && option[0].loadCostPerBushel
    };
    },
    () => {
    this.getExternalDestinationLoadCost();
    }
    );
    };
  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        this.setState({
          isValid: validForm(this.state.formErrors)
        });
      }
    );
  };

  createTicket = e => {
    console.log(this.state.ticketInfo);
    this.setState({
      isValid: true,
      edited: false
    });
    e.preventDefault();
    const { ticketInfo } = this.state;
    ticketInfo.harvestYear = harvestYearDetail().name;
    const formData = { ...ticketInfo };
    if (formData.destinationTypeId === "1") {
      (formData.counterpartId = null),
        (formData.primaryContractNumber = null),
        (formData.secondaryContractNumber = null),
        (formData.type = null),
        (formData.billOfLading = null);
    }
    formData['counterPartyEnum'] = this.state.ONBOARDED
    formData.primaryContractNumber = formData.primaryContractNumber || null;
    formData.comments = formData.comments || null;
    formData.secondaryContractNumber = formData.primaryContractNumber;
    formData.id = userFarmDetail().id || this.MainFarmId;
    formData.shrinkMultiplier = parseFloat(formData.shrinkMultiplier || 0);
    if (formData.originTypeId == 2) {
      delete formData.secondarySourceId;
      delete formData.secondaryFieldSplit;
    }
    console.log(formData,'checkOnboarded')

    this.props.submitFunction(formData);
  };

  getfilterCommodityList = commodityVarietyList => {
    let comm = commodityVarietyList !== undefined ? commodityVarietyList : {};

    let commarray = [];
    commarray = Object.keys(comm).map(value => {
      return {
        id: comm[value].commodityResponseDTO.id,
        name: comm[value].commodityResponseDTO.name
      };
    });
    const filteredArr = commarray.reduce((acc, current) => {
      const x = acc.find(item => item.id === current.id);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredArr;
  };

  getContractOptionsList = ContractList => {
    let comm = ContractList !== undefined ? ContractList : {};
    let commarray = [];
    commarray = Object.keys(comm)
      .filter(
        value =>
          !comm[value].disable &&
          comm[value].contractStageResponseDTO.stage === "Agreed"
      )
      .map(value => {
        return {
          id: comm[value].name,
          name: `${comm[value].name} (${comm[value].counterpartResponseDTO.name})`
        };
      });
    return commarray;
  };
  getVariertyList = (id, VarietyId) => {

    let mode = this.props.editMode;
    let selectedVariety = this.props.ticketInfo
    ? this.props.ticketInfo.commodityVarietyId
    : "";
    const { commodityVarietyList } = this.props;
    let option = commodityVarietyList.filter(
    value => value.commodityResponseDTO.id === id
    );
    var optionindex
    var i;
    for (i = 0; i < option.length; i++) {
    if(option[i].name==="General")
    {
    if(VarietyId==undefined){
    optionindex=option[i].id
    }
    else{
    optionindex=VarietyId
    }
    }
    }
    console.log('index',optionindex)
    this.setState(prevState => {
    return {
    ...prevState,
    commodityVarietyListOption: option,
    ticketInfo: {
    ...prevState.ticketInfo,
    commodityVarietyId:
    mode && !this.handleVarietyonEdit
    ? selectedVariety
    : VarietyId
    ? VarietyId
    // : option[0].id
    :optionindex
    }
    };
    
    }, this.getEstimatedHomeScaleShrinkBushels());
    this.handleVarietyonEdit = true;
    };

  checkShrinkMultiplier = () => {
    const { shrinkMultiplier } = this.state.ticketInfo;
    return parseFloat(shrinkMultiplier || 0) <= 1;
  };

  handleExtendedDetails = () => {
    this.setState({ checked: !this.state.checked });
  };

  handleDateChange = date => {
    if (!this.state.edited) this.setState({ edited: true });
    if (date) {
      this.setState({
        ticketInfo: {
          ...this.state.ticketInfo,
          loadDate: new Date(date).toISOString()
        }
      });
    }
    this.props.checkValidation(this.state.ticketInfo);
  };

  getEstimatedHomeScaleShrinkBushels = () => {
    //this.getcommidityLoadBushlesValue();
    const { ticketInfo, commodityVarietyLbsPerBushel } = this.state;

    if (
      ticketInfo.homeScaleWeightFilled &&
      ticketInfo.homeScaleWeightEmpty &&
      commodityVarietyLbsPerBushel
    ) {
      let calHomeScaleShrinkBushels = (
        ((ticketInfo.homeScaleWeightFilled - ticketInfo.homeScaleWeightEmpty) /
          commodityVarietyLbsPerBushel) *
          ticketInfo.shrinkMultiplier || 0
      ).toFixed(4);

      this.setState({
        ticketInfo: {
          ...this.state.ticketInfo,
          estimatedHomeScaleShrinkBushels: Number(calHomeScaleShrinkBushels)
        }
      });
    }
  };

  getExternalDestinationLoadCost = () => {
    
    const {
      ticketInfo,
      destinationLoadCost,
      commodityVarietyLbsPerBushel
    } = this.state;
    const fieldEstimatedLoadWeightEstimate = Number(
      ticketInfo.fieldEstimatedLoadWeight
    );
    
    if (
      fieldEstimatedLoadWeightEstimate &&
      commodityVarietyLbsPerBushel !== null &&
      destinationLoadCost !== null
    ) {
      console.log(this.props,fieldEstimatedLoadWeightEstimate,commodityVarietyLbsPerBushel,destinationLoadCost,ticketInfo.fieldEstimatedLoadWeight, "loadvalue")
      let ExternalDestinationLoadCost = parseFloat(
        (ticketInfo.fieldEstimatedLoadWeight / commodityVarietyLbsPerBushel) *
          destinationLoadCost
      ).toFixed(2);

      if (
        ExternalDestinationLoadCost === "Infinity" ||
        ExternalDestinationLoadCost === "NaN"
      ) {
        ExternalDestinationLoadCost = 0;
      }
       else {
        ExternalDestinationLoadCost = ExternalDestinationLoadCost;
      }

      this.setState({
        ticketInfo: {
          ...this.state.ticketInfo,
          loadCost: Number(ExternalDestinationLoadCost)
        }
      });
    } else {
      this.setState({
        ticketInfo: {
          ...this.state.ticketInfo,
          loadCost:0
        }
      });
    }
  };

  checkEmptyVsFilled = () => {
    const {
      homeScaleWeightEmpty,
      homeScaleWeightFilled
    } = this.state.ticketInfo;
    console.log(`${homeScaleWeightEmpty} and ${homeScaleWeightFilled}`);
    return parseFloat(homeScaleWeightEmpty) > parseFloat(homeScaleWeightFilled);
  };
  checkSecondaryvsPrimary = () => {
    const { primarySourceId, secondarySourceId } = this.state.ticketInfo;
    // console.log(primarySourceId && secondarySourceId && primarySourceId = == secondarySourceId , "check")
    return (
      primarySourceId &&
      secondarySourceId &&
      primarySourceId === secondarySourceId
    );
  };

  updateMandate = () => {
    console.log("updateMandate");

    const { secondarySourceId, secondaryFieldSplit } = this.state.ticketInfo;

    if (secondarySourceId) {
      this.setState(
        state => {
          const mandatoryFields = [
            ...state.mandatoryFields,
            "secondaryFieldSplit"
          ];
          return {
            ...state,
            mandatoryFields
          };
        },
        () => {
          console.log(this.state.mandatoryFields);
        }
      );
      this.setState({
        isEnableShowSplit: false
      });
    } else if (!secondarySourceId) {
      this.setState(
        state => {
          const currmandatoryFields = [...state.mandatoryFields];
          const index = currmandatoryFields.indexOf("secondaryFieldSplit");
          if (index >= 0) currmandatoryFields.splice(index, 1);
          return {
            ...state,
            mandatoryFields: currmandatoryFields
          };
        },
        () => {
          console.log(this.state.mandatoryFields);
        }
      );
      this.setState(prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            secondaryFieldSplit: ""
          }
        };
      });
      this.setState({
        isEnableShowSplit: true
      });
      this.setState(prevState => {
        return {
          ticketInfo: {
            ...prevState.ticketInfo,
            secondaryFieldSplit: ""
          }
        };
      });
    }
  };

  isCellRequired = cellName => {
    const { mandatoryFields } = this.state;
    return mandatoryFields.includes(cellName);
  };

  showExtendedDetails = () => {
    const { mandatoryFields = [] } = this.state;
    const extendedCells = [
      "homeScaleWeightFilled",
      "homeScaleWeightEmpty",
      "homeScaleEstimatedMoisture",
      "shrinkMultiplier"
    ];
    const isChecked = mandatoryFields.some(item =>
      extendedCells.includes(item)
    );
    this.setState({ checked: isChecked });
  };

  checkAllMandatoryCellsAreFilled = () => {
    const { mandatoryFields = [], ticketInfo } = this.state;
    let mFields = [];
    let nonMandatory = [
      "billOfLading",
      "primaryContractNumber",
      "counterpartId"
    ];
    
    if (ticketInfo.destinationTypeId === "1") {
      mFields = mandatoryFields.filter(function(item) {
        return !nonMandatory.includes(item);
      });
    } 
    else {
      mFields = mandatoryFields;
    }
    let blankCells = 0;
    blankCells = mFields.map(
      cell => ticketInfo[cell] === "" || ticketInfo[cell] === undefined
    );
    return blankCells.includes(true);
  };

  render() {
    const {
      commodityVarietyListOption,
      // isValid,
      originTypeOptions,
      DestinationOptionList,
      suggestedFieldOriginTypeOptions = { primary: [], secondary: [] },
      suggestedInternalOriginTypeOptions = [],
      suggestedDestinationOptionList = { ticket: [], contract: [] },
      checked,
      successMessage,
      formErrors,
      ticketInfo,
      edited,
      fetchingComplete,
      showSecondaryFields
    } = this.state;
    const {
      ContractTypeList,
      BrokerList,
      LoadNumberIndicatorList,
      trucksListOptions,
      suggestedTrucklist,
      formLabel,
      buttonLabel,
      isValid,
      classes,
      editMode = false
    } = this.props;
    if (successMessage) {
      return <Redirect to="/app/tickets" />;
    }
    const { mandatoryFields = [] } = this.state;
    
    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells <br/>
        ⚠️ Plan is expired <br/>
        ✅ Onboarded Counterparty</div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {editMode ? (
            <LogInfo
              createdBy={ticketInfo.createdBy}
              updatedBy={ticketInfo.updatedBy}
              createdAt={ticketInfo.createdAt}
              updatedAt={ticketInfo.updatedAt}
            />
          ) : (
            <div />
          )}
        </div>
        {fetchingComplete ? (
          <div className="innermainform">
            <p className="loginHeader">{formLabel}</p>
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <label className="maturity-label">Load Date </label>
                  <DatePicker
                    className="date-picker"
                    disabled
                    format="MMM dd, yyyy p"
                    value={ticketInfo.loadDate}
                    name="loadDate"
                    onChange={this.handleDateChange}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12}>
                <InputFiled
                  value={ticketInfo.ticketNumber}
                  label="Ticket Number"
                  type="text"
                  validations={["onlyAlpha", "required"]}
                  name="ticketNumber"
                  handleError={this.handleError}
                  handleChange={this.handleChange}
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <RadioElement
                  handleChange={this.handleChange}
                  options={TabsConstants.destinationTypeId}
                  name="destinationTypeId"
                  label="Destination Type"
                  value={ticketInfo.destinationTypeId}
                />
              </Grid>
              {ticketInfo.destinationTypeId === defaultDestinationTypeId && (
                <div style={{ display: "block", width: "100%" }}>
                  <Grid item xs={12}>
                    <Dropdown
                      value={ticketInfo.primaryContractNumber}
                      label="Contract Number"
                      type="text"
                      name="primaryContractNumber"
                      options={this.getContractOptionsList(
                        this.props.ContractList
                      )}
                      suggestedData={this.getContractOptionsList(
                        this.props.suggestedContracts
                      )}
                      required={this.isCellRequired("primaryContractNumber")}
                      validations={
                        this.isCellRequired("primaryContractNumber")
                          ? ["required"]
                          : []
                      }
                      handleChange={this.handleChange}
                      handleError={this.handleError}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Dropdown
                      value={ticketInfo.counterpartId}
                      label="Counterpart"
                      required
                      type="text"
                      name="counterpartId"
                      options={BrokerList}
                      suggestedData={this.props.suggestedCounterparts}
                      fieldError={formErrors.counterpartId}
                      validations={["required"]}
                      handleChange={this.handleChange}
                      handleError={this.handleError}
                    />
                  </Grid>
                  {/* <Grid item xs={12}>
                  <Dropdown
                    value={ticketInfo.type}
                    label="Contract Type"
                    // required
                    type="text"
                    options={ContractTypeList}
                    name="type"
                    // validations={['required']}
                    handleChange={this.handleChange}
                    handleError={this.handleError}
                  />
                </Grid> */}
                </div>
              )}
              <Grid item xs={12}>
                {/* {<InputFiled
                value={ticketInfo.loadDate}
                label="Load Date"
                required
                type="date"
                name="loadDate"
                validations={["required"]}
                handleError={this.handleError}
                handleChange={this.handleChange}
              />} */}
                {/* <DatePicker
                onSelect={date => this.onDateSelect(date)}
                minDate={moment()}
                label="Load Date"
                value={ticketInfo.loadDate}
              /> */}
              </Grid>
              <Grid item xs={12}>
                <Dropdown
                  value={ticketInfo.destinationId}
                  label={
                    ticketInfo.destinationTypeId === defaultDestinationTypeId
                      ? "Delivery Destination"
                      : "Destination"
                  }
                  type="text"
                  name="destinationId"
                  options={DestinationOptionList}
                  suggestedData={suggestedDestinationOptionList.ticket}
                  required
                  validations={["required"]}
                  fieldError={formErrors.destinationId}
                  handleError={this.handleError}
                  handleChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <Dropdown
                  value={ticketInfo.commodityId}
                  label="Commodity"
                  required
                  type="text"
                  name="commodityId"
                  fieldError={formErrors.commodityId}
                  options={this.getfilterCommodityList(
                    this.props.commodityVarietyList
                  )}
                  suggestedData={this.getfilterCommodityList(
                    this.props.suggestedVariety
                  )}
                  validations={["required"]}
                  handleChange={this.handleChange}
                  handleError={this.handleError}
                  // disabled={
                  //   ticketInfo.destinationTypeId === defaultDestinationTypeId
                  // }
                />
              </Grid>
              <Grid item xs={6}>
                <Dropdown
                  value={ticketInfo.commodityVarietyId}
                  label="Variety"
                  required
                  type="text"
                  name="commodityVarietyId"
                  validations={["required"]}
                  fullform={ticketInfo}
                  options={commodityVarietyListOption}
                  handleChange={this.handleChange}
                  fieldError={formErrors.commodityVarietyId}
                  handleError={this.handleError}
                  disabled={
                    commodityVarietyListOption.length > 0 ? false : true 
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <Dropdown
                  value={ticketInfo.originTypeId}
                  label="Origin Type"
                  required={this.isCellRequired("originTypeId")}
                  type="text"
                  name="originTypeId"
                  options={TabsConstants.OriginTypeSelection}
                  validations={["required"]}
                  fieldError={formErrors.originTypeId}
                  handleChange={this.handleChange}
                  handleError={this.handleError}
                />
              </Grid>
              <Grid item xs={6}>
                <Dropdown
                  value={ticketInfo.primarySourceId}
                  label={
                    ticketInfo.originTypeId
                      ? originTypes[ticketInfo.originTypeId]
                      : "Origin"
                  }
                  required
                  type="text"
                  name="primarySourceId"
                  options={originTypeOptions}
                  suggestedData={
                    ticketInfo.originTypeId
                      ? ticketInfo.originTypeId == 1
                        ? suggestedFieldOriginTypeOptions.primary
                        : suggestedInternalOriginTypeOptions.ticket
                      : []
                  }
                  validations={["required"]}
                  fieldError={formErrors.primarySourceId}
                  handleChange={this.handleChange}
                  handleError={this.handleError}
                />
              </Grid>

              {showSecondaryFields && (
                <Grid item xs={6}>
                  <Dropdown
                    value={ticketInfo.secondarySourceId}
                    label="Secondary Field (optional)"
                    // required
                    type="text"
                    name="secondarySourceId"
                    // disableSelectOption={true}
                    options={originTypeOptions}
                    suggestedData={suggestedFieldOriginTypeOptions.secondary}
                    // validations={["required"]}
                    fieldError={formErrors.secondarySourceId}
                    handleChange={this.handleChange}
                    handleError={this.handleError}
                  />
                  {this.checkSecondaryvsPrimary() && (
                    <FormHelperText style={{ color: "red" }}>
                      Secondary Field can not be same as Primary Field.
                    </FormHelperText>
                  )}
                </Grid>
              )}

              {showSecondaryFields && (
                <Grid item xs={6}>
                  <InputFiled
                    value={ticketInfo.secondaryFieldSplit}
                    label="Secondary Field Split %"
                    type="text"
                    name="secondaryFieldSplit"
                    disabled={this.state.isEnableShowSplit}
                    validations={
                      this.isCellRequired("secondaryFieldSplit")
                        ? ["required", "percentageCheck"]
                        : ticketInfo.secondarySourceId
                        ? ["required", "percentageCheck"]
                        : ["percentageCheck"]
                    }
                    required={
                      this.isCellRequired("secondaryFieldSplit")
                        ? true
                        : ticketInfo.secondarySourceId &&
                          ticketInfo.secondarySourceId !== undefined
                        ? true
                        : false
                    }
                    handleChange={this.handleChange}
                    handleError={this.handleError}
                    fieldError={formErrors.secondaryFieldSplit}
                  />
                </Grid>
              )}

              {/* <Grid item xs={12}>
                <Dropdown
                  value={ticketInfo.destinationId}
                  label={
                    ticketInfo.destinationTypeId === defaultDestinationTypeId
                      ? "Delivery Destination"
                      : "Destination"
                  }
                  type="text"
                  name="destinationId"
                  options={DestinationOptionList}
                  suggestedData={suggestedDestinationOptionList.ticket}
                  required
                  validations={["required"]}
                  fieldError={formErrors.destinationId}
                  handleError={this.handleError}
                  handleChange={this.handleChange}
                />
              </Grid> */}
              <Grid item xs={12}>
                <Dropdown
                  value={ticketInfo.trucklineId}
                  label="Truckline"
                  required={
                    this.isCellRequired("trucklineId")
                      ? true
                      : ticketInfo.destinationTypeId ===
                          defaultDestinationTypeId && true
                  }
                  type="text"
                  name="trucklineId"
                  disableSelectOption={true}
                  options={trucksListOptions}
                  suggestedData={suggestedTrucklist}
                  validations={
                    this.isCellRequired("trucklineId")
                      ? ["required"]
                      : ticketInfo.destinationTypeId ===
                          defaultDestinationTypeId && ["required"]
                  }
                  handleError={this.handleError}
                  handleChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <InputFiled
                  value={ticketInfo.truckNumber}
                  label="Truck Number"
                  type="text"
                  name="truckNumber"
                  fieldError={formErrors.truckNumber}
                  required={this.isCellRequired("truckNumber")}
                  validations={
                    this.isCellRequired("truckNumber")
                      ? ["required", "codeSize"]
                      : ["codeSize"]
                  }
                  handleError={this.handleError}
                  handleChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <InputFiled
                  value={ticketInfo.trailerNumber}
                  label="Trailer Number"
                  type="text"
                  name="trailerNumber"
                  required={this.isCellRequired("trailerNumber")}
                  validations={
                    this.isCellRequired("truckNumber")
                      ? ["required", "codeSize"]
                      : ["codeSize"]
                  }
                  handleError={this.handleError}
                  handleChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <InputFiled
                  value={ticketInfo.driverName}
                  label="Truck Driver's Name"
                  type="text"
                  name="driverName"
                  fieldError={formErrors.driverName}
                  required={
                    this.isCellRequired("driverName")
                      ? true
                      : ticketInfo.trucklineId
                      ? true
                      : false
                  }
                  validations={
                    this.isCellRequired("driverName")
                      ? ["required", "maxSize"]
                      : ticketInfo.trucklineId
                      ? ["required", "maxSize"] //"onlyAlpha"
                      : ["maxSize"] //"onlyAlpha"
                  }
                  handleError={this.handleError}
                  handleChange={this.handleChange}
                />
                <Grid item xs={12}>
                  <Dropdown
                    value={ticketInfo.loadNumberIndicatorId}
                    disabled={editMode}
                    label="Load No Indicator"
                    required
                    type="text"
                    name="loadNumberIndicatorId"
                    options={LoadNumberIndicatorList}
                    suggestedData={this.props.suggestedLoadNumber}
                    validations={["required"]}
                    fieldError={formErrors.loadNumberIndicatorId}
                    handleError={this.handleError}
                    handleChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputFiled
                    value={ticketInfo.loadNumber}
                    label="Load Number"
                    type="text"
                    name="loadNumber"
                    options={LoadNumberIndicatorList}
                    // validations={['required']}
                    handleError={this.handleError}
                    handleChange={this.handleChange}
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputFiled
                    value={ticketInfo.scaleTicketNumber}
                    label="Scale Ticket Number"
                    required={this.isCellRequired("scaleTicketNumber")}
                    type="text"
                    name="scaleTicketNumber"
                    validations={
                      this.isCellRequired("scaleTicketNumber")
                        ? ["required", "codeSize"]
                        : ["codeSize"]
                    }
                    handleError={this.handleError}
                    handleChange={this.handleChange}
                  />
                </Grid>
                {ticketInfo.destinationTypeId === defaultDestinationTypeId && (
                  <Grid item xs={12}>
                    <InputFiled
                      value={ticketInfo.billOfLading}
                      label="Bill of Lading"
                      required={this.isCellRequired("billOfLading")}
                      type="text"
                      name="billOfLading"
                      validations={
                        this.isCellRequired("billOfLading")
                          ? ["required", "codeSize"]
                          : ["codeSize"]
                      }
                      handleError={this.handleError}
                      handleChange={this.handleChange}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <InputFiled
                    value={ticketInfo.fieldEstimatedLoadWeight}
                    label="Field Estimated Load Weight (lbs)"
                    type="text"
                    name="fieldEstimatedLoadWeight"
                    required={this.isCellRequired("fieldEstimatedLoadWeight")}
                    validations={
                      this.isCellRequired("fieldEstimatedLoadWeight")
                        ? ["required"]
                        : []
                    }
                    handleError={this.handleError}
                    handleChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputFiled
                    value={ticketInfo.fieldEstimatedLoadBushels}
                    label="Field Estimated Load Bushels"
                    type="text"
                    required={this.isCellRequired("fieldEstimatedLoadBushels")}
                    validations={
                      this.isCellRequired("fieldEstimatedLoadBushels")
                        ? ["required"]
                        : []
                    }
                    name="fieldEstimatedLoadBushels"
                    handleChange={this.handleChange}
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputFiled
                    value={ticketInfo.fieldsEstimatedMoisture}
                    label="Field Estimated Moisture %"
                    type="text"
                    name="fieldsEstimatedMoisture"
                    validations={
                      this.isCellRequired("fieldsEstimatedMoisture")
                        ? ["required", "percentageCheck"]
                        : ["percentageCheck"]
                    }
                    required={this.isCellRequired("fieldsEstimatedMoisture")}
                    handleChange={this.handleChange}
                    handleError={this.handleError}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={this.handleExtendedDetails}
                          name="ExtendedDetails"
                          classes={{
                            root: classes.root,
                            checked: classes.checked
                          }}
                        />
                      }
                      label="Show Extended Load Details"
                      className="mycheckbox"
                    />
                  </FormGroup>
                </Grid>
                {checked && (
                  <div style={{ display: "block", width: "100%" }}>
                    <Grid item xs={12}>
                      <InputFiled
                        value={ticketInfo.homeScaleWeightFilled}
                        label="Home Scale Weight Filled (lbs)"
                        validations={
                          this.isCellRequired("homeScaleWeightFilled")
                            ? ["required", "onlyNumber"]
                            : ["onlyNumber"]
                        }
                        type="text"
                        required={this.isCellRequired("homeScaleWeightFilled")}
                        name="homeScaleWeightFilled"
                        handleChange={this.handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputFiled
                        value={ticketInfo.homeScaleWeightEmpty}
                        label="Home Scale Weight Empty or Tare (lbs)"
                        type="text"
                        validations={
                          this.isCellRequired("homeScaleWeightEmpty")
                            ? ["required", "onlyNumber"]
                            : ["onlyNumber"]
                        }
                        required={this.isCellRequired("homeScaleWeightEmpty")}
                        name="homeScaleWeightEmpty"
                        handleChange={this.handleChange}
                      />
                      {this.checkEmptyVsFilled() && (
                        <FormHelperText style={{ color: "red" }}>
                          Home scale weight empty can not be greater than Home
                          scale weight filled.
                        </FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      <InputFiled
                        value={ticketInfo.homeScaleEstimatedMoisture}
                        label="Home Scale Estimated Moisture %"
                        type="text"
                        validations={
                          this.isCellRequired("homeScaleEstimatedMoisture")
                            ? ["required", "percentageCheck"]
                            : ["percentageCheck"]
                        }
                        required={this.isCellRequired(
                          "homeScaleEstimatedMoisture"
                        )}
                        name="homeScaleEstimatedMoisture"
                        handleChange={this.handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputFiled
                        value={ticketInfo.shrinkMultiplier}
                        label="Field Shrink Multiplier"
                        type="text"
                        required={this.isCellRequired("shrinkMultiplier")}
                        validations={
                          this.isCellRequired("shrinkMultiplier")
                            ? ["required"]
                            : []
                        }
                        name="shrinkMultiplier"
                        handleChange={this.handleChange}
                      />
                    </Grid>
                    {!this.checkShrinkMultiplier() && (
                      <FormHelperText>
                        <span className="error" role="alert">
                          Shrink Multiplier can not be greater then 1.
                        </span>
                      </FormHelperText>
                    )}
                    <Grid item xs={12}>
                      <InputFiled
                        value={ticketInfo.estimatedHomeScaleShrinkBushels}
                        label="Estimated Home Scale Shrunk Bushels"
                        type="text"
                        required={this.isCellRequired(
                          "estimatedHomeScaleShrinkBushels"
                        )}
                        validations={
                          this.isCellRequired("estimatedHomeScaleShrinkBushels")
                            ? ["required"]
                            : []
                        }
                        name="estimatedHomeScaleShrinkBushels"
                        disabled
                      />
                    </Grid>
                  </div>
                )}
                {/* {ticketInfo.loadCost && ticketInfo.loadCost.length > 0 && ( */}
                <Grid item xs={12}>
                  <InputFiled
                    value={ticketInfo.loadCost}
                    label="Load Cost"
                    type="text"
                    name="loadCost"
                    // handleChange={this.handleChange}
                    disabled
                  />
                </Grid>
                {/* )} */}
                <Grid item xs={12}>
                  <InputFiled
                    value={ticketInfo.comments}
                    label="Notes"
                    type="text"
                    name="comments"
                    multiline={true}
                    rows={2}
                    rowsMax={4}
                    required={this.isCellRequired("comments")}
                    validations={
                      this.isCellRequired("comments")
                        ? ["required", "aboveMaxSize"]
                        : ["aboveMaxSize"]
                    }
                    handleChange={this.handleChange}
                  />
                </Grid>
              </Grid>
            </Grid>
            <div className="signInSection" style={signInSectionStyle}>
              <Link to="/app/tickets" style={{ color: "blue" }}>
                Cancel
              </Link>
              <Button
                name={buttonLabel}
                disabled={
                   (!ticketInfo.trucklineId && ticketInfo.destinationTypeId==="1"?this.state.isValid:isValid) ||
                  //isValid||
                  this.checkEmptyVsFilled() ||
                  !this.checkShrinkMultiplier() ||
                  this.checkAllMandatoryCellsAreFilled() ||
                  this.checkSecondaryvsPrimary()
                }
                onclick={this.createTicket}
                styleClass="signIn"
              />
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    ticketCreated: state.ticketReducer.ticketCreated,
    ContractList: state.contractReducer.ContractList,
    commodityList: state.contractReducer.commodityList,
    commodityVarietyList: state.contractReducer.commodityVarietyList,
    ContractStageList: state.contractReducer.ContractStageList,
    ContractTypeList: state.contractReducer.ContractTypeList,
    BrokerList: state.ticketReducer.CounterPart,
    OriginTypeDestinationOptions: state.ticketReducer.originTypeInternal,
    LoadNumberIndicatorList: state.ticketReducer.LoadNumberIndicatorList,
    ExternalDestinationOptions: state.contractReducer.DestinationList,
    InternalDestinationOptions: state.contractReducer.InternalDestinationList,
    selectedContractDetails: state.contractReducer.selectedContractDetails,
    trucksListOptions: state.trucklineReducer.trucksList,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    indicatorCodeCount: state.ticketReducer.indicatorCodeCount,
    mandatoryFieldsList: state.mandatoryFieldsReducer.MandatoryFieldsList,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    suggestedOriginType: state.ticketReducer.suggestedOriginType,
    suggestedExternalOptions: state.contractReducer.suggestedExternalOptions,
    suggestedInternalOptions: state.contractReducer.suggestedInternalOptions,
    suggestedTrucklist: state.trucklineReducer.suggestedTrucklist,
    suggestedLoadNumber: state.ticketReducer.suggestedLoadNumber,
    suggestedContracts: state.contractReducer.suggestedContracts,
    suggestedCounterparts: state.ticketReducer.suggestedCounterparts
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        commodityList,
        getCommodityVariertyList,
        getCounterpartList,
        getContractStage,
        getContractType,
        getAllContractList,
        getOriginType,
        getDestinationByType,
        getLoadNumberIndicatorList,
        createNewTicket,
        InternalDestinationList,
        trucklineListAction,
        getSelectedContractDetail,
        getLoadIndicatorCodeCount,
        getMandatoryFieldsList
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TicketForm));



// WEBPACK FOOTER //
// ./src/components/private/Tickets/TicketForm.js